import React from 'react';
import DesktopDevPageStage728x90Gak from './gak/DesktopDevPageStage728x90';
const DesktopDevPageStage728x90 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopDevPageStage728x90Gak, {
        safety: safety
    });
};
DesktopDevPageStage728x90.displayName = 'DesktopDevPageStage728x90';
export default DesktopDevPageStage728x90;
